export class LoginModel {
  ProjectName: string = "";
  AuthenticateType: string = "";
  UserNameMaxlength: number = 0;
  PasswordMaxlength: number = 0;
  SQAnswerMaxlength: number = 0;
  ErrorMsg: string = "";
  UserNameFormat: string = "";
  UserNameMsg: string = "";
  PasswordFormat: string = "";
  PasswordFormatReset: string = "";
  PasswordMsg: string = "";
  AuthenticateAPI: string = "";
  ForgotPasswordAPI: string = "";
  LoginId: string = "";
  Password:string="";
  SSOAuthenticateAPI: string = "";
  SQSListAPI: string = "";
  Mfvendorlist: string = "";
  SSOEnable: boolean;
}
